<template>
  <div>
    <p>
      User is logged in: {{loggedIn}}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      loggedIn: 'users/loggedIn',
    }),
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/AccountSettings.vue